import React from 'react';

interface FiltrosUsuariosProps {
  filtros: {
    nome: string;
    email: string;
    matricula: string;
    perfil: string;
  };
  onFiltroChange: (campo: string, valor: string) => void;
}

const FiltrosUsuarios: React.FC<FiltrosUsuariosProps> = ({ filtros, onFiltroChange }) => {
  return (
    <div className="filtros-container">
      <div className="filtros-grid">
        <div className="form-group">
          <label>Nome</label>
          <input 
            type="text" 
            className="form-control" 
            value={filtros.nome} 
            onChange={(e) => onFiltroChange('nome', e.target.value)} 
            placeholder="Digite o nome" 
          />
        </div>
        <div className="form-group">
          <label>Email</label>
          <input 
            type="text" 
            className="form-control" 
            value={filtros.email} 
            onChange={(e) => onFiltroChange('email', e.target.value)} 
            placeholder="Digite o email" 
          />
        </div>
        <div className="form-group">
          <label>Matrícula</label>
          <input 
            type="text" 
            className="form-control" 
            value={filtros.matricula} 
            onChange={(e) => onFiltroChange('matricula', e.target.value)} 
            placeholder="Digite a matrícula" 
          />
        </div>
        <div className="form-group">
          <label>Perfil</label>
          <input 
            type="text" 
            className="form-control" 
            value={filtros.perfil} 
            onChange={(e) => onFiltroChange('perfil', e.target.value)} 
            placeholder="Digite o perfil" 
          />
        </div>
      </div>
    </div>
  );
};

export default FiltrosUsuarios;